import { ROLES_NAME } from "modules/utilities/utility";

export const FORM_DATA = {
  FN: [
    {
      id: "phone_number",
      component: "inputPhoneNumber",
      group: "basic_information",
      next: "first_name",
      reply: "",
      sub_text: "",
      tag: "user",
      text: "Phone Number",
      type: "tel",
    },
    {
      id: "first_name",
      component: "inputName",
      group: "basic_information",
      next: "email",
      reply: "",
      tag: "user",
      text: "Before we start, can we get your name?",
      type: "text",
    },

    {
      id: "email",
      component: "inputEmail",
      group: "basic_information",
      next: "C1d",
      reply: "",
      tag: "user",
      text: "Email Address",
      type: "text",
    },
    {
      id: "C1d",
      component: "inputAge",
      group: "basic_information",
      next: "gender",
      reply: "",
      tag: "form",
      text: "Age",
      type: "tel",
    },
    {
      id: "gender",
      component: "inputGender",
      group: "basic_information",
      next: "hairFallIntensity",
      reply: "",
      tag: "user",
      text: "Gender",
      type: "single_choice",
      optionMap: [
        {
          name: "Male",
          value: "M",
        },
        {
          name: "Female",
          value: "F",
        },
      ],
      fn: {
        if: [
          {
            "==": [
              {
                var: "reply",
              },
              "M",
            ],
          },
          "2e",
          "hair_type",
        ],
      },
    },
    {
      "id": "hairFallIntensity",
      "component": "inputRadio",
      "group": "know_your_hair",
      "next": "hairFallTimeframe",
      "showImages": true,
      "reply": "",
      "tag": "form",
      "text": "How much hairfall do you experience while oiling, combing or washing your hair?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "Normal hairfall ~20 strands",
          "value": "Normal hairfall ~20 strands",
          "image_url": "female_hair_test/oiling/o1.png"
        },
        {
          "name": "I notice a bigger clump than normal ~ 40-50 strands",
          "value": "I notice a bigger clump than normal ~ 40-50 strands",
          "image_url": "female_hair_test/oiling/o2.png"
        },
        {
          "name": "I get very big clumps of hair, more than 100 hair strands",
          "value": "I get very big clumps of hair, more than 100 hair strands",
          "image_url": "female_hair_test/oiling/o3.png"
        }
      ]
    },
    {
      "id": "hairFallTimeframe",
      "component": "inputRadioV4",
      "group": "know_your_hair",
      "next": "hairLossStage",
      "reply": "",
      "tag": "form",
      "text": "How long have you been experiencing increased hairfall?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "Less than 6 months",
          "value": "Less than 6 months"
        },
        {
          "name": "6 months to 2 year",
          "value": "6 months to 2 year"
        },
        {
          "name": "2 year to 5 years",
          "value": "2 year to 5 years"
        },
        {
          "name": "More than 5 years",
          "value": "More than 5 years"
        },
        {
          "name": "Not Applicable",
          "value": "Not Applicable"
        }
      ]
    },
    {
      "id": "hairLossStage",
      "component": "inputRadio",
      "group": "know_your_hair",
      "next": "hairQualityFeelLike",
      "checkSubgroup": true,
      "showImages": true,
      "reply": "",
      "tag": "form",
      "text": "What is your current hair volume like?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "Hair volume has not changed much",
          "value": "Hair volume has not changed much",
          "image_url": "female_hair_test/o1.png"
        },
        {
          "name": "Hair volume has reduced, but no thinning in any specific area",
          "value": "Hair volume has reduced, but no thinning in any specific area",
          "image_url": "female_hair_test/o2.png"
        },
        {
          "name": "Hair volume has reduced, with overall thinning",
          "value": "Hair volume has reduced, with overall thinning",
          "image_url": "female_hair_test/o3.png"
        },
        {
          "name": "Hair volume has reduced, with front or side thinning",
          "value": "Hair volume has reduced, with front or side thinning",
          "image_url": "female_hair_test/o4.png"
        },
        {
          "name": "Partition is becoming wider, and some scalp is seen",
          "value": "Partition is becoming wider, and some scalp is seen",
          "image_url": "female_hair_test/o6.png"
        },
        {
          "name": "Partition has widened a lot, and scalp is clearly visible",
          "value": "Partition has widened a lot, and scalp is clearly visible",
          "image_url": "female_hair_test/o5.png"
        },
        {
          "name": "Seeing coin sized bald patches on my head",
          "value": "Seeing coin sized bald patches on my head",
          "image_url": "female_hair_test/o7.png"
        }
      ]
    },
    {
      "id": "hairQualityFeelLike",
      "component": "inputRadioV4",
      "group": "know_your_hair",
      "next": "hairTreatment",
      "reply": "",
      "tag": "form",
      "text": "What does your hair feel like, when you touch it?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "My hair feels soft and silky",
          "value": "My hair feels soft and silky"
        },
        {
          "name": "My hair feels frizzy, dry, damaged",
          "value": "My hair feels frizzy, dry, damaged"
        },
        {
          "name": "Somedays silky, somedays frizzy",
          "value": "Somedays silky, somedays frizzy"
        }
      ]
    },
    {
      "id": "hairTreatment",
      "component": "inputCheckbox",
      "group": "know_your_hair",
      "next": "scalpDandruff",
      "reply": "",
      "sub_text": "Select at least one option",
      "tag": "form",
      "text": "What hair treatments have you done in the past 2 years?",
      "type": "multiple_choice",
      "optionMap": [
        {
          "name": "None",
          "value": "None"
        },
        {
          "name": "Smoothening or Straightening treatments",
          "value": "Smoothening or Straightening treatments"
        },
        {
          "name": "Chemical hair coloring",
          "value": "Chemical hair coloring"
        },
        {
          "name": "Natural hair coloring - henna",
          "value": "Natural hair coloring - henna"
        },
        {
          "name": "Anti hair fall treatment",
          "value": "Anti hair fall treatment"
        }
      ]
    },
    {
      "id": "scalpDandruff",
      "component": "inputRadioV4",
      "group": "know_your_hair",
      "next": "hairGenetics",
      "reply": "",
      "tag": "form",
      "text": "What is your experience with dandruff these days?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "No Dandruff at all",
          "value": "No Dandruff at all"
        },
        {
          "name": "No Dandruff on wash day, but appears 2-3 days after",
          "value": "No Dandruff on wash day, but appears 2-3 days after"
        },
        {
          "name": "Always see visible dandruff flakes or powder around hair or shoulder",
          "value": "Always see visible dandruff flakes or powder around hair or shoulder"
        },
        {
          "name": "Scalp is always itchy with sticky dandruff under nails upon scratching",
          "value": "Scalp is always itchy with sticky dandruff under nails upon scratching"
        },
        {
          "name": "I have psoriasis or seborrheic dermatitis",
          "value": "I have psoriasis or seborrheic dermatitis"
        }
      ]
    },
    {
      "id": "hairGenetics",
      "component": "inputRadioV4",
      "group": "know_your_hair",
      "next": "healthConditions",
      "reply": "",
      "tag": "form",
      "text": "Is hair loss a genetic issue in your family?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "Yes, my mother or mother's side of family",
          "value": "Yes, my mother or mother's side of family"
        },
        {
          "name": "Yes, my father or father's side of family",
          "value": "Yes, my father or father's side of family"
        },
        {
          "name": "Both sides of the family",
          "value": "Both sides of the family"
        },
        {
          "name": "No, not a genetic issue",
          "value": "No, not a genetic issue"
        }
      ]
    },
    {
      "id": "healthConditions",
      "component": "inputCheckbox",
      "group": "lifestyle_questions",
      "next": "pcosSelfDiagnosis",
      "reply": "",
      "sub_text": "Select at least one option",
      "tag": "form",
      "text": "Do you have any of these health conditions currently?",
      "type": "multiple_choice",
      "optionMap": [
        {
          "name": "None",
          "value": "None"
        },
        {
          "name": "Anaemia",
          "value": "Anaemia"
        },
        {
          "name": "Low or High Blood Pressure",
          "value": "Low or High Blood Pressure"
        },
        {
          "name": "Low Thyroid (Hypo Thyroidism)",
          "value": "Low Thyroid (Hypo Thyroidism)"
        },
        {
          "name": "Other Hormonal Issues",
          "value": "Other Hormonal Issues"
        },
        {
          "name": "Asthama/Sinus Issue",
          "value": "Asthama/Sinus Issue"
        },
        {
          "name": "Diabetic/Pre-diabetic",
          "value": "Diabetic/Pre-diabetic"
        },
        {
          "name": "Blood disorders (Epilepsy/History of stroke)",
          "value": "Blood disorders (Epilepsy/History of stroke)"
        },
        {
          "name": "Liver Cirrhosis or Deranged LFT(Liver function test)",
          "value": "Liver Cirrhosis or Deranged LFT(Liver function test)"
        },
        {
          "name": "High Cholestrol",
          "value": "High Cholestrol"
        }
      ]
    },
    {
      "id": "pcosSelfDiagnosis",
      "component": "inputCheckbox",
      "group": "lifestyle_questions",
      "next": "femaleLifestage",
      "reply": "",
      "sub_text": "Select at least one option",
      "tag": "form",
      "text": "Which of these do you tend to experience?",
      "type": "multiple_choice",
      "optionMap": [
        {
          "name": "I have acne located along the jawline or chin",
          "value": "I have acne located along the jawline or chin"
        },
        {
          "name": "I have excessive facial hair",
          "value": "I have excessive facial hair"
        },
        {
          "name": "I have irregular periods",
          "value": "I have irregular periods"
        },
        {
          "name": "I have PCOS",
          "value": "I have PCOS"
        },
        {
          "name": "None",
          "value": "None"
        }
      ]
    },
    {
      "id": "femaleLifestage",
      "component": "inputRadioV4",
      "group": "lifestyle_questions",
      "next": "majorHealthIssue",
      "reply": "",
      "tag": "form",
      "text": "Are you going through any of these life stages currently?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "Planning to get Pregnant sometime soon",
          "value": "Planning to get Pregnant sometime soon"
        },
        {
          "name": "Currently Pregnant",
          "value": "Currently Pregnant"
        },
        {
          "name": "Post Pregnancy - My baby is less than 1 year old",
          "value": "Post Pregnancy - My baby is less than 1 year old"
        },
        {
          "name": "Menopause - I don’t get my periods anymore",
          "value": "Menopause - I don’t get my periods anymore"
        },
        {
          "name": "None",
          "value": "None"
        }
      ]
    },
    {
      "id": "majorHealthIssue",
      "component": "inputCheckbox",
      "group": "lifestyle_questions",
      "next": "gutHealth",
      "reply": "",
      "sub_text": "Select at least one option",
      "tag": "form",
      "text": "Have you experienced any of these in the last 1 year?",
      "type": "multiple_choice",
      "optionMap": [
        {
          "name": "I gained or lost a lot of weight",
          "value": "I gained or lost a lot of weight"
        },
        {
          "name": "I suffered from severe illness (Dengue, Malaria, Typhoid)",
          "value": "I suffered from severe illness (Dengue, Malaria, Typhoid)"
        },
        {
          "name": "I had a surgery",
          "value": "I had a surgery"
        },
        {
          "name": "I was on heavy medication",
          "value": "I was on heavy medication"
        },
        {
          "name": "I moved to a new location or my water supply changed",
          "value": "I moved to a new location or my water supply changed"
        },
        {
          "name": "My hair is greying",
          "value": "My hair is greying"
        },
        {
          "name": "None",
          "value": "None"
        }
      ]
    },
    {
      "id": "gutHealth",
      "component": "inputCheckbox",
      "group": "lifestyle_questions",
      "next": "sleepPattern",
      "reply": "",
      "sub_text": "Select at least one option",
      "tag": "form",
      "text": "Which of these best describe your stomach/digestion issues these days?",
      "type": "multiple_choice",
      "optionMap": [
        {
          "name": "I have no stomach discomfort and bowel movements are mostly regular",
          "value": "I have no stomach discomfort and bowel movements are mostly regular"
        },
        {
          "name": "I often feel bloated or gassy (frequent burping/farting/heavy stomach)",
          "value": "I often feel bloated or gassy (frequent burping/farting/heavy stomach)"
        },
        {
          "name": "I am often constipated (kabz)",
          "value": "I am often constipated (kabz)"
        },
        {
          "name": "I often have diarrhoea (loose motions)",
          "value": "I often have diarrhoea (loose motions)"
        },
        {
          "name": "I have acidity (khatti dakaare/burning sensation in stomach/throat/chest)",
          "value": "I have acidity (khatti dakaare/burning sensation in stomach/throat/chest)"
        },
        {
          "name": "I have serious gut issues (Irritable bowel syndrome/Gastric-peptic ulcers)",
          "value": "I have serious gut issues (Irritable bowel syndrome/Gastric-peptic ulcers)"
        }
      ]
    },
    {
      "id": "sleepPattern",
      "component": "inputRadioV4",
      "group": "lifestyle_questions",
      "next": "stressLevels",
      "reply": "",
      "tag": "form",
      "text": "How well do you sleep these days?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "Peacefully for 6-8 hours",
          "value": "Peacefully for 6-8 hours"
        },
        {
          "name": "I have difficulty falling asleep",
          "value": "I have difficulty falling asleep"
        },
        {
          "name": "Disturbed sleep, I wake up atleast once a night",
          "value": "Disturbed sleep, I wake up atleast once a night"
        },
        {
          "name": "I sleep for less than 5 hours, as I am very busy",
          "value": "I sleep for less than 5 hours, as I am very busy"
        },
        {
          "name": "It varies - somedays I get good sleep, somedays I don't",
          "value": "It varies - somedays I get good sleep, somedays I don't"
        }
      ]
    },
    {
      "id": "stressLevels",
      "component": "inputRadioV4",
      "group": "lifestyle_questions",
      "next": "energyLevels",
      "reply": "",
      "tag": "form",
      "text": "How would you describe your stress level these days?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "I feel calm and relaxed most days, with no major worries.",
          "value": "I feel calm and relaxed most days, with no major worries."
        },
        {
          "name": "I feel tensed 1-2 times a week, but it’s manageable.",
          "value": "I feel tensed 1-2 times a week, but it’s manageable."
        },
        {
          "name": "I feel tensed 3-5 times a week, and it affects my mood or focus.",
          "value": "I feel tensed 3-5 times a week, and it affects my mood or focus."
        },
        {
          "name": "I feel tensed almost every day, and it disrupts my sleep or daily life.",
          "value": "I feel tensed almost every day, and it disrupts my sleep or daily life."
        }
      ]
    },
    {
      "id": "energyLevels",
      "component": "inputRadioV4",
      "group": "lifestyle_questions",
      "next": "supplementsIntake",
      "reply": "",
      "tag": "form",
      "text": "How would you describe your typical energy during the day?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "I always feel energetic",
          "value": "I always feel energetic"
        },
        {
          "name": "Energetic during the day, but low/tired by evening/night",
          "value": "Energetic during the day, but low/tired by evening/night"
        },
        {
          "name": "Low/tired when I wake up, but gradually feel more energetic",
          "value": "Low/tired when I wake up, but gradually feel more energetic"
        },
        {
          "name": "Experience occasional instances of low energy",
          "value": "Experience occasional instances of low energy"
        },
        {
          "name": "I always feel tired and low on energy",
          "value": "I always feel tired and low on energy"
        }
      ]
    },
    {
      "id": "supplementsIntake",
      "component": "inputRadioV4",
      "group": "lifestyle_questions",
      "next": "dietaryHabits",
      "reply": "",
      "tag": "form",
      "text": "Are you currently taking any supplements or vitamins for hair?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "Yes",
          "value": "Yes"
        },
        {
          "name": "No",
          "value": "No"
        }
      ]
    },
    {
      "id": "dietaryHabits",
      "component": "inputRadioV4",
      "group": "lifestyle_questions",
      "next": "photo_q",
      "reply": "",
      "tag": "form",
      "text": "Which of the these best describe your Food Habits on most days?",
      "type": "single_choice",
      "optionMap": [
        {
          "name": "I mostly eat healthy homely meals, on time",
          "value": "I mostly eat healthy homely meals, on time"
        },
        {
          "name": "I mostly eat healthy homely food, but often skip meals",
          "value": "I mostly eat healthy homely food, but often skip meals"
        },
        {
          "name": "I often eat junk food (more than 5 times a week)",
          "value": "I often eat junk food (more than 5 times a week)"
        }
      ]
    }

  ],
  FO: [
    {
      id: "phone_number",
      component: "inputPhoneNumber",
      group: "basic_information",
      next: "first_name",
      reply: "",
      sub_text: "",
      tag: "user",
      text: "Phone Number",
      type: "tel",
    },
    {
      id: "first_name",
      component: "inputName",
      group: "basic_information",
      next: "email",
      reply: "",
      tag: "user",
      text: "Before we start, can we get your name?",
      type: "text",
    },
    {
      id: "email",
      component: "inputEmail",
      group: "basic_information",
      next: "C1d",
      reply: "",
      tag: "user",
      text: "Email Address",
      type: "text",
    },
    {
      id: "C1d",
      component: "inputAge",
      group: "basic_information",
      next: "gender",
      reply: "",
      tag: "form",
      text: "Age",
      type: "tel",
    },
    {
      id: "gender",
      component: "inputGender",
      group: "basic_information",
      next: "hair_type",
      reply: "",
      tag: "user",
      text: "Gender",
      type: "single_choice",
      optionMap: [
        {
          name: "Male",
          value: "M",
        },
        {
          name: "Female",
          value: "F",
        },
      ],
      fn: {
        if: [
          {
            "==": [
              {
                var: "reply",
              },
              "M",
            ],
          },
          "2e",
          "hair_type",
        ],
      },
    },
    {
      id: "hair_type",
      component: "inputRadioV4",
      group: "know_your_hair",
      next: "hair_goals2",
      reply: "",
      tag: "form",
      text: "What does your hair look like naturally?",
      type: "single_choice",
      optionMap: [
        {
          name: "Straight",
          value: "Straight",
        },
        {
          name: "Wavy",
          value: "Wavy",
        },
        {
          name: "Curly",
          value: "Curly",
        },
        {
          name: "Coily",
          value: "Coily",
        },
      ],
    },
    {
      id: "hair_goals2",
      component: "inputRadioV4",
      group: "know_your_hair",
      next: "feel_hair_fall",
      reply: "",
      tag: "form",
      text: "What is your most important goal currently?",
      type: "single_choice",
      optionMap: [
        {
          name: "Control Hairfall",
          value: "Control Hairfall",
        },
        {
          name: "Regrow Hair",
          value: "Regrow Hair",
        },
        {
          name: "Improve Hair Quality",
          value: "Improve Hair Quality",
        },
      ],
    },
    {
      id: "feel_hair_fall",
      component: "inputRadioV4",
      group: "know_your_hair",
      next: "hair_vol1",
      reply: "",
      tag: "form",
      text: "Do you feel like you're facing Hair Fall more than usual?",
      type: "single_choice",
      optionMap: [
        {
          name: "Yes, extreme hair fall",
          value: "Yes, extreme hair fall",
        },
        {
          name: "Mild hair fall",
          value: "Mild hair fall",
        },
        {
          name: "No Hair fall",
          value: "No Hair fall",
        },
      ],
    },
    {
      id: "hair_vol1",
      component: "inputRadio",
      group: "know_your_hair",
      next: "hair_quality",
      checkSubgroup: true,
      showImages: true,
      reply: "",
      tag: "form",
      text: "Where do you stand on the Female Hair Scale?",
      sub_text: "Which picture best describes your current hair condition ",
      type: "single_choice",
      optionMap: [
        {
          name: "Hair Thinning",
          value: "Hair Thinning",
          image_url: "female-hair-fall-describe/hairThinningBefore.png",
          sub_text: "Loss of hair volume overall, no visible scalp",
        },
        {
          name: "Less volume on the sides",
          value: "side_widening",
          image_url: "female-hair-fall-describe/side_widening.png",
          sub_text: "Scalp visible on sides",
        },
        {
          name: "Medium Widening",
          value: "Medium Widening",
          image_url: "female-hair-fall-describe/newMediumWidening.png",
          sub_text: "Increased gap in middle partition",
        },
        {
          name: "Advanced Widening",
          value: "Advanced Widening",
          image_url: "female-hair-fall-describe/newAdvancedWidening.png",
          sub_text: "Extreme hair thinning on the partition",
        },
        {
          name: "Coin size patches",
          value: "Coin size patches",
          image_url: "female-hair-fall-describe/newCoin.png",
          sub_text: "Small patches on head or other body parts",
        },
      ],
    },
    {
      id: "hair_quality",
      component: "inputRadio",
      group: "know_your_hair",
      next: "hair_feel",
      reply: "",
      tag: "form",
      text: "Describe your hair quality",
      type: "single_choice",
      optionMap: [
        {
          name: "Good Hair Quality",
          value: "Good Hair Quality",
        },
        {
          name: "Damaged Hair",
          value: "Damaged Hair",
        },
      ],
      fn: {
        if: [
          {
            "==": [
              {
                var: "reply",
              },
              "Damaged Hair",
            ],
          },
          "hair_quality1",
          "hair_feel",
        ],
      },
    },
    {
      id: "hair_feel",
      component: "inputRadioV4",
      group: "know_your_hair",
      next: "fhf2",
      reply: "",
      tag: "form",
      text: "What does a single strand of your hair feel like?",
      type: "single_choice",
      optionMap: [
        {
          name: "Thin",
          value: "Thin",
        },
        {
          name: "Medium",
          value: "Medium",
        },
        {
          name: "Thick",
          value: "Thick",
        },
      ],
    },
    {
      id: "fhf2",
      component: "inputRadio",
      group: "know_your_hair",
      next: "feel_oily",
      reply: "",
      tag: "form",
      text: "Is hair loss a genetic issue in your family?",
      type: "single_choice",
      optionMap: [
        {
          name: "Yes, Mother or mother's side of family",
          value: "Yes, Mother or mother's side of family",
        },
        {
          name: "Yes, Father or father's side of family",
          value: "Yes, Father or father's side of family",
        },
        {
          name: "Both",
          value: "Both",
        },
        {
          name: "None",
          value: "None",
        },
      ],
    },
    {
      id: "feel_oily",
      component: "inputRadioV4",
      group: "know_your_hair",
      next: "describe_dandruff",
      reply: "",
      tag: "form",
      text: "How long after hair wash does your hair start to feel oily?",
      type: "single_choice",
      optionMap: [
        {
          name: "Within 24 hours",
          value: "Within 24 hours",
        },
        {
          name: "2-3 days",
          value: "2-3 days",
        },
        {
          name: "More than 4 days",
          value: "More than 4 days",
        },
      ],
    },
    {
      id: "describe_dandruff",
      component: "inputRadioV4",
      group: "know_your_hair",
      next: "female_stage",
      reply: "",
      tag: "form",
      text: "Describe your dandruff.",
      type: "single_choice",
      optionMap: [
        {
          name: "No",
          value: "No",
        },
        {
          name: "Yes, Mild that comes & goes",
          value: "Yes, Mild that comes & goes",
        },
        {
          name: "Yes, Heavy dandruff that sticks to the scalp",
          value: "Yes, Heavy dandruff that sticks to the scalp",
        },
        {
          name: "I have Psoriasis",
          value: "I have Psoriasis",
        },
        {
          name: "I have Seborrheic Dermatitis",
          value: "I have Seborrheic Dermatitis",
        },
      ],
    },
    {
      id: "female_stage",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "female_experiance",
      reply: "",
      tag: "form",
      text: "Are you going through any of these stages?",
      type: "single_choice",
      optionMap: [
        {
          name: "None",
          value: "None",
        },
        {
          name: "Planning to get pregnant",
          value: "Planning to get pregnant",
        },
        {
          name: "Pregnancy",
          value: "Pregnancy",
        },
        {
          name: "Post-pregnancy (Baby is less than 2 years old)",
          value: "Post-pregnancy",
        },
        {
          name: "Menopause",
          value: "Menopause",
        },
      ],
      fn: {
        if: [
          {
            "==": [
              {
                var: "reply",
              },
              "Post-pregnancy",
            ],
          },
          "fs2",
          "female_experiance",
        ],
      },
    },
    {
      id: "fs2",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "female_experiance",
      reply: "",
      tag: "form",
      text: "Are you currently breast feeding?",
      type: "single_choice",
      optionMap: [
        {
          name: "Yes",
          value: "Yes",
        },
        {
          name: "No",
          value: "No",
        },
      ],
    },
    {
      id: "female_experiance",
      component: "inputCheckbox",
      group: "lifestyle_questions",
      next: "female_cond",
      reply: "",
      sub_text: "Select at least one option",
      tag: "form",
      text: "Have you experienced any of the below in last 1 year?",
      type: "multiple_choice",
      optionMap: [
        {
          name: "None",
          value: "None",
        },
        {
          name: "Severe Illness (Dengue, Malaria, Typhoid or Covid)",
          value: "Severe Illness (Dengue, Malaria, Typhoid or Covid)",
        },
        {
          name: "Heavy weight loss or heavy weight gain",
          value: "Heavy weight loss or heavy weight gain",
        },
        {
          name: "Surgery or on heavy medication",
          value: "Surgery or on heavy medication",
        },
      ],
    },
    {
      id: "female_cond",
      component: "inputCheckbox",
      group: "lifestyle_questions",
      next: "vitamin_def_female_combined",
      reply: "",
      sub_text: "Select at least one option",
      tag: "form",
      text: "Are you going through any of the below?",
      checkSubgroup: true,
      type: "multiple_choice",
      optionMap: [
        {
          name: "None",
          value: "None",
        },
        {
          name: "Anemia (Low Haemoglobin)",
          value: "Anemia (Low Haemoglobin)",
        },
        {
          name: "Low Thyroid (Hypothyroidism)",
          value: "Low Thyroid (Hypothyroidism)",
        },
        {
          name: "PCOS",
          value: "PCOS",
        },
        {
          name: "Other Hormonal Issues",
          value: "Other Hormonal Issues",
        },
      ],
    },
    {
      id: "vitamin_def_female_combined",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "sleep_check",
      reply: "",
      tag: "form",
      text: "Are you currently taking any supplements or vitamins for hair?",
      type: "single_choice",
      optionMap: [
        {
          name: "No",
          value: "No",
        },
        {
          name: "Yes",
          value: "Yes",
        },
      ],
      whyWeAsk: {
        show: true,
        text: "Several vitamin deficiencies can lead to compromised hair and skin health. Hence, we ask for this information to recommend a supplement formula that's balanced for you while preventing vitamin overdose.",
      },
    },
    {
      id: "sleep_check",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "asthma_sinus",
      reply: "",
      tag: "form",
      text: "How well do you sleep",
      type: "single_choice",
      optionMap: [
        {
          name: "Peacefully for 6-8 hours",
          value: "Peacefully for 6-8 hours",
        },
        {
          name: "Disturbed sleep, I wake up atleast once a night",
          value: "Disturbed sleep, I wake up atleast once a night",
        },
        {
          name: "Have difficulty falling asleep",
          value: "Have difficulty falling asleep",
        },
      ],
    },
    {
      id: "asthma_sinus",
      component: "inputCheckbox",
      group: "lifestyle_questions",
      next: "stress_check",
      reply: "",
      tag: "form",
      text: "Do you currently experience any of the following health conditions?",
      type: "multiple_choice",
      optionMap: [
        {
          name: "None",
          value: "None",
        },
        {
          name: "Sinus Issue",
          value: "sinus",
        },
        {
          name: "Asthma",
          value: "asthma",
        },
      ],
      whyWeAsk: {
        show: false,
        text: "Asthma and sinus can  affect your hair treatment and recomendation",
      },
    },
    {
      id: "stress_check",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "feel_consitpate",
      reply: "",
      tag: "form",
      text: "How stressed are you",
      type: "single_choice",
      optionMap: [
        {
          name: "Not at all",
          value: "Not at all",
        },
        {
          name: "Low",
          value: "Low",
        },
        {
          name: "Moderate",
          value: "Moderate",
        },
        {
          name: "High",
          value: "High",
        },
      ],
    },
    {
      id: "feel_consitpate",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "check_bloat",
      reply: "",
      tag: "form",
      text: "Do you feel constipated?",
      type: "single_choice",
      optionMap: [
        {
          name: "No",
          value: "No",
        },
        {
          name: "Yes",
          value: "Yes",
        },
        {
          name: "I have IBS",
          value: "I have IBS",
        },
      ],
    },
    {
      id: "check_bloat",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "energy_level",
      reply: "",
      tag: "form",
      text: "Do you have Acidity, Bloating, Gas or Indigestion?",
      type: "single_choice",
      optionMap: [
        {
          name: "No",
          value: "No",
        },
        {
          name: "Yes",
          value: "Yes",
        },
      ],
    },
    {
      id: "energy_level",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "female_bp",
      reply: "",
      tag: "form",
      text: "Describe your energy levels",
      type: "single_choice",
      optionMap: [
        {
          name: "Always high",
          value: "Always high",
        },
        {
          name: "Low when I wake up, but gradually increases",
          value: "Low when I wake up, but gradually increases",
        },
        {
          name: "Very low in the afternoon",
          value: "Very low in the afternoon",
        },
        {
          name: "Low by evening/ night",
          value: "Low by evening/ night",
        },
        {
          name: "Always low",
          value: "Always low",
        },
      ],
    },
    {
      id: "female_bp",
      component: "inputCheckbox",
      group: "lifestyle_questions",
      next: "",
      reply: "",
      tag: "form",
      text: "Are you suffering through any of these medical conditions?",
      sub_text: "Select at least one option",
      type: "multiple_choice",
      optionMap: [
        {
          name: "None",
          value: "None",
        },
        {
          name: "High Blood Pressure",
          value: "High Blood Pressure",
        },
        {
          name: "Low Blood Pressure",
          value: "Low Blood Pressure",
        },
        {
          name: "Liver Cirrhosis or deranged LFT (Liver Function Test)",
          value: "Liver Cirrhosis or deranged LFT ",
        },
        {
          name: "Blood disorders (epilepsy, history of stroke)",
          value: "Blood disorders",
        },
        {
          name: "Cardiovascular disorders (history of heart attack, arrhythmia, pace maker, stroke)",
          value: "Cardiovascular disorders",
        },
      ],
    },
  ],
  M: [
    {
      id: "phone_number",
      component: "inputPhoneNumber",
      group: "basic_information",
      next: "first_name",
      reply: "",
      sub_text: "",
      tag: "user",
      text: "Phone Number",
      type: "tel",
    },
    {
      id: "first_name",
      component: "inputName",
      group: "basic_information",
      next: "email",
      reply: "",
      tag: "user",
      text: "Before we start, can we get your name?",
      type: "text",
    },

    {
      id: "email",
      component: "inputEmail",
      group: "basic_information",
      next: "C1d",
      reply: "",
      tag: "user",
      text: "Email Address",
      type: "text",
    },
    {
      id: "C1d",
      component: "inputAge",
      group: "basic_information",
      next: "gender",
      reply: "",
      tag: "form",
      text: "Age",
      type: "tel",
    },
    {
      id: "gender",
      component: "inputGender",
      group: "basic_information",
      next: "2e",
      reply: "",
      tag: "user",
      text: "Gender",
      type: "single_choice",
      optionMap: [
        {
          name: "Male",
          value: "M",
        },
        {
          name: "Female",
          value: "F",
        },
      ],
      fn: {
        if: [
          {
            "==": [
              {
                var: "reply",
              },
              "M",
            ],
          },
          "2e",
          "hair_type",
        ],
      },
    },
    {
      id: "2e",
      component: "inputRadioV4",
      group: "hair_assessment",
      next: "2c",
      reply: "",
      showImages: true,
      tag: "form",
      text: "Which image best describes your hair loss?",
      hindi_text: "In mein se kaunsi photo aap ke hair loss jaisi dikhti hain?",
      type: "single_choice",
      optionMap: [
        {
          name: "Stage-1",
          hindi_name: "Stage-1",
          value: "Stage-1",
          id: "Stage-1",
          image_url: "male/stage1.svg",
          destination_image_url: "male/stage1_t.svg",
        },
        {
          name: "Stage-2",
          hindi_name: "Stage-2",
          value: "Stage-2",
          id: "Stage-2",
          image_url: "male/stage2.svg",
          destination_image_url: "male/stage2_t.svg",
        },
        {
          name: "Stage-3",
          hindi_name: "Stage-3",
          value: "Stage-3",
          id: "Stage-3",
          image_url: "male/stage3.svg",
          destination_image_url: "male/stage3_t.svg",
        },
        {
          name: "Stage-4",
          hindi_name: "Stage-4",
          value: "Stage-4",
          id: "Stage-4",
          image_url: "male/stage4.svg",
          destination_image_url: "male/stage4_t.svg",
        },
        {
          name: "Stage-5",
          hindi_name: "Stage-5",
          value: "Stage-5",
          id: "Stage-5",
          image_url: "male/stage5.svg",
          destination_image_url: "male/stage5_t.svg",
        },
        {
          name: "Stage-6",
          hindi_name: "Stage-6",
          value: "Stage-6",
          id: "Stage-6",
          image_url: "male/stage6.svg",
          destination_image_url: "male/stage6_t.svg",
        },
        {
          name: "Coin Size Patch",
          hindi_name: "Coin Size Patch",
          value: "Coin Size Patch",
          id: "Stage-7",
          image_url: "male/coin-size.svg",
          destination_image_url: "male/coin-size_t.svg",
        },
        {
          name: "Heavy Hair Fall",
          hindi_name: "Heavy Hair Fall",
          value: "Heavy Hair Fall",
          id: "Stage-8",
          image_url: "male/hair-fall.svg",
          destination_image_url: "male/hair-fall_t.svg",
        },
      ],
    },
    {
      id: "2c",
      component: "inputRadioV4",
      group: "hair_assessment",
      next: "male_experiance",
      reply: "",
      tag: "form",
      text: "Do you have a family history of hair loss?",
      hindi_text: "Kya aap ke family mein kisiko hair loss hain?",
      type: "single_choice",
      optionMap: [
        {
          name: "Mother or anyone from mother's side of the family",
          hindi_name: "Aap ki maa ya unki family ki taraf se",
          value: "Mother or anyone from mother's side of the family",
        },
        {
          name: "Father or anyone from father's side of the family",
          hindi_name: "Aap ke pita ya unki family ki taraf se",
          value: "Father or anyone from father's side of the family",
        },
        {
          name: "Both",
          hindi_name: "Dono",
          value: "Both",
        },
        {
          name: "None",
          hindi_name: "Dono taraf se nahi",
          value: "None",
        },
      ],
    },
    {
      id: "male_experiance",
      component: "inputCheckbox",
      group: "hair_assessment",
      next: "male-branch",
      reply: "",
      sub_text: "Select at least one option",
      tag: "form",
      text: "Have you experienced any of the below in the last 1 year?",
      hindi_text:
        "Kya aapne pichle 1 saal mein, in mein se kuch experience kiya hain?",
      type: "multiple_choice",
      optionMap: [
        {
          name: "None",
          hindi_name: "Kuch Nahi",
          value: "None",
        },
        {
          name: "Severe Illness (Dengue, Malaria, Typhoid or Covid)",
          hindi_name: "Serious Bimari (Dengue, Malaria, Typhoid or Covid)",
          value: "Severe Illness (Dengue, Malaria, Typhoid or Covid)",
        },
        {
          name: "Heavy weight loss / heavy weight gain",
          hindi_name: "Zyada weight loss / Zyada weight gain",
          value: "Heavy weight loss / heavy weight gain",
        },
        {
          name: "Surgery / heavy medication",
          hindi_name: "Surgery / Zyada medication",
          value: "Surgery / heavy medication",
        },
      ],
    },
    {
      id: "male-branch",
      component: "inputRadioV4",
      group: "hair_assessment",
      next: "male-dandruff-pic",
      reply: "",
      tag: "form",
      text: "Do you have dandruff?",
      hindi_text: "Kya aap ko dandruff hain?",
      type: "single_choice",
      optionMap: [
        {
          name: "No",
          hindi_name: "Nahi",
          value: "No",
        },
        {
          name: "Yes, mild that comes and goes",
          hindi_name: "Haan, aata-jaata rehta hain",
          value: "Yes, mild that comes and goes",
        },
        {
          name: "Yes, heavy dandruff that sticks to the scalp",
          hindi_name: "Haan, heavy dandruff jo scalp se chipakta hain",
          value: "Yes, heavy dandruff that sticks to the scalp",
        },
        {
          name: "I have Psoriasis",
          hindi_name: "Mujhe Psoriasis hain",
          value: "I have Psoriasis",
        },
        {
          name: "I have Seborrheic Dermatitis",
          hindi_name: "Mujhe Seborrheic Dermatitis hain",
          value: "I have Seborrheic Dermatitis",
        },
      ],
    },
    {
      id: "male-dandruff-duration_offline",
      component: "inputRadioV4",
      group: "hair_assessment",
      next: "3e",
      reply: "",
      tag: "form",
      text: "When do you face dandruff?",
      hindi_text: "Aap ko dandruff ka problem kabse hain?",
      type: "single_choice",
      disabled: false,
      optionMap: [
        {
          name: "Seasonal",
          hindi_name: "Seasonal",
          value: "Seasonal",
        },
        {
          name: "Always",
          hindi_name: "Always",
          value: "Always",
        },
      ],
      whyWeAsk: {
        show: false,
        text: "Helps in better prescription of kit.",
      },
    },
    {
      id: "3e",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "3d",
      reply: "",
      tag: "form",
      text: "How well do you sleep?",
      hindi_text: "Kya aap ko theek se neend aati hain?",
      type: "single_choice",
      optionMap: [
        {
          name: "Very peacefully for 6 to 8 hours",
          hindi_name: "Acche se, 6-8 ghanto tak",
          value: "Very peacefully for 6 to 8 hours",
        },
        {
          name: "Disturbed sleep, I wake up at least one time during the night",
          hindi_name:
            "Disturbed neend, raat mein at least ek baar jaag jaata hu",
          value:
            "Disturbed sleep, I wake up at least one time during the night",
        },
        {
          name: "Have difficulty falling asleep",
          hindi_name: "Neend aane mein mushkil hoti hain",
          value: "Have difficulty falling asleep",
        },
      ],
    },
    {
      id: "3d",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "male_health_condition",
      reply: "",
      tag: "form",
      text: "How stressed are you?",
      hindi_text: "Aap ko kitna stress hota hain?",
      type: "single_choice",
      optionMap: [
        {
          name: "None",
          hindi_name: "Bilkul bhi nahi",
          value: "None",
        },
        {
          name: "Low",
          hindi_name: "Kam",
          value: "Low",
        },
        {
          name: "Moderate(work, family etc )",
          hindi_name: "Thoda-bahut (Office, family, wagerah)",
          value: "Moderate(work, family etc )",
        },
        {
          name: "High (Loss of close one, separation, home, illness)",
          hindi_name:
            "Bahut zyada (Kisi kareebi ko khona, bichadna, ghar, bimari)",
          value: "High (Loss of close one, separation, home, illness)",
        },
      ],
    },
    {
      id: "male_health_condition",
      component: "inputCheckbox",
      group: "lifestyle_questions",
      next: "3c",
      reply: "",
      tag: "form",
      text: "Are you currently dealing with any of these health conditions?",
      hindi_text: "Kya aap inme se kisi swasthya samasya se guzar rahe hain?",
      type: "multiple_choice",
      optionMap: [
        {
          name: "None",
          hindi_name: "Koi bhi nahi",
          value: "None",
        },
        {
          name: "Anemia (Low Iron/Haemoglobin)",
          hindi_name: "Anemia (Iron / Haemoglobin ki kami)",
          value: "Anemia (Low Iron/Haemoglobin)",
        },
        {
          name: "Low Thyroid (Hypothyroidism)",
          hindi_name: "Thyroid level mein kami (Hypothyroidism)",
          value: "Low Thyroid (Hypothyroidism)",
        },
        {
          name: "Asthma",
          hindi_name: "Asthma",
          value: "Asthma",
        },
        {
          name: "Sinus Problems",
          hindi_name: "Sinus ki samasya",
          value: "Sinus Problems",
        },
      ],
    },
    {
      id: "3c",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "3b",
      reply: "",
      tag: "form",
      text: "Do you feel constipated?",
      hindi_text: "Kya aap ko kabz ka problem hota hain?",
      type: "single_choice",
      optionMap: [
        {
          name: "No/Rarely",
          hindi_name: "Nahi/ Shayad hi kabhi",
          value: "No/Rarely",
        },
        {
          name: "Yes",
          hindi_name: "Haan",
          value: "Yes",
        },
        {
          name: "Unsatisfactory bowel movements",
          hindi_name: "Theek se pet saaf nahi hota",
          value: "Unsatisfactory bowel movements",
        },
        {
          name: "Suffering from IBS (irritable bowel syndrome) /dysentery",
          hindi_name:
            "IBS (irritable bowel syndrome) /dysentery ka problem hain",
          value: "Suffering from IBS (irritable bowel syndrome) /dysentery",
        },
      ],
      fn: {
        if: [
          {
            "==": [
              {
                var: "reply",
              },
              "No/Rarely",
            ],
          },
          "3di",
          "3b",
        ],
      },
    },
    {
      id: "3b",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "3f1",
      reply: "",
      tag: "form",
      text: "How are your energy levels?",
      hindi_text: "Aap ke energy levels kaise hain?",
      type: "single_choice",
      optionMap: [
        {
          name: "Always high",
          hindi_name: "Hamesha zyada",
          value: "Always high",
        },
        {
          name: "Low when I wake up, but gradually increases",
          hindi_name: "Neend se uthke kam, phir dheere-dheere badhta hain",
          value: "Low when I wake up, but gradually increases",
        },
        {
          name: "Very low in afternoon",
          hindi_name: "Dopahar mein bahut kam",
          value: "Very low in afternoon",
        },
        {
          name: "Low by evening/night",
          hindi_name: "Shaam/raat tak kam",
          value: "Low by evening/night",
        },
        {
          name: "Always low",
          hindi_name: "Hamesha kam",
          value: "Always low",
        },
      ],
    },
    {
      id: "3f1",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "3j",
      reply: "",
      tag: "form",
      text: "Are you currently taking any supplements or vitamins for hair?",
      hindi_text: "Kya aap koi hair vitamins ya supplements le rahe hain?",
      type: "single_choice",
      optionMap: [
        {
          name: "Yes",
          hindi_name: "Haan",
          value: "Yes",
          id: "Answer 1",
        },
        {
          name: "No",
          hindi_name: "Nahi",
          value: "No",
          id: "Answer 2",
        },
        {
          name: "Not Sure",
          hindi_name: "Pata nahi",
          value: "Not Sure",
          id: "Answer 3",
        },
      ],
    },
    {
      id: "3j",
      component: "inputRadioV4",
      group: "lifestyle_questions",
      next: "",
      reply: "",
      tag: "form",
      text: "Do you have Blood Pressure problem?",
      hindi_text: "Kya aap ko blood pressure ka problem hain?",
      type: "single_choice",
      optionMap: [
        {
          name: "None",
          hindi_name: "Nahi",
          value: "None",
        },
        {
          name: "Yes, high BP issue",
          hindi_name: "Haan, high BP ka issue hain",
          value: "Yes, high BP issue",
        },
        {
          name: "Yes, low BP issue",
          hindi_name: "Haan, low BP ka issue hain",
          value: "Yes, low BP issue",
        },
      ],
    },
  ],
};


export const QUESTION_MAPPER = {
  FO: {
    C1d: "Age",
    gender: "Gender",
    hair_type: "What does your hair look like naturally?",
    hair_goals2: "What is your most important goal currently?",
    feel_hair_fall: "Do you feel like you're facing Hair Fall more than usual?",
    hair_vol1: "Where do you stand on the Female Hair Scale?",
    hair_quality: "Describe your hair quality",
    hair_feel: "What does a single strand of your hair feel like?",
    fhf2: "Is hair loss a genetic issue in your family?",
    feel_oily: "How long after hair wash does your hair start to feel oily?",
    describe_dandruff: "Describe your dandruff.",
    female_stage: "Are you going through any of these stages?",
    fs2: "Are you currently breast feeding?",
    female_experiance: "Have you experienced any of the below in last 1 year?",
    female_cond: "Are you going through any of the below?",
    vitamin_def_female_combined: "Are you currently taking any supplements or vitamins for hair?",
    sleep_check: "How well do you sleep",
    asthma_sinus: "Do you currently experience any of the following health conditions?",
    stress_check: "How stressed are you",
    feel_consitpate: "Do you feel constipated?",
    check_bloat: "Do you have Acidity, Bloating, Gas or Indigestion?",
    energy_level: "Describe your energy levels",
    female_bp: "Are you suffering through any of these medical conditions?",
  },
  FN: {
    phone_number: "Phone Number",
    first_name: "Before we start, can we get your name?",
    email: "Email Address",
    C1d: "Age",
    gender: "Gender",
    hairFallIntensity: "How much hairfall do you experience while oiling, combing or washing your hair?",
    hairFallTimeframe: "How long have you been experiencing increased hairfall?",
    hairLossStage: "What is your current hair volume like?",
    hairQualityFeelLike: "What does your hair feel like, when you touch it?",
    hairTreatment: "What hair treatments have you done in the past 2 years?",
    scalpDandruff: "What is your experience with dandruff these days?",
    hairGenetics: "Is hair loss a genetic issue in your family?",
    healthConditions: "Do you have any of these health conditions currently?",
    pcosSelfDiagnosis: "Which of these do you tend to experience?",
    femaleLifestage: "Are you going through any of these life stages currently?",
    majorHealthIssue: "Have you experienced any of these in the last 1 year?",
    gutHealth: "Which of these best describe your stomach/digestion issues these days?",
    sleepPattern: "How well do you sleep these days?",
    stressLevels: "How would you describe your stress level these days?",
    energyLevels: "How would you describe your typical energy during the day?",
    supplementsIntake: "Are you currently taking any supplements or vitamins for hair?",
    dietaryHabits: "Which of the these best describe your Food Habits on most days?"
  },
  M: {
    C1d: "Age",
    gender: "Gender",
    "2e": "Which image best describes your hair loss?",
    "2c": "Do you have a family history of hair loss?",
    male_experiance: "Have you experienced any of the below in the last 1 year?",
    "male-branch": "Do you have dandruff?",
    "male-dandruff-duration_offline": "When do you face dandruff?",
    "3e": "How well do you sleep?",
    "3d": "How stressed are you?",
    male_health_condition: "Are you currently dealing with any of these health conditions?",
    "3c": "Do you feel constipated?",
    "3b": "How are your energy levels?",
    "3f1": "Are you currently taking any supplements or vitamins for hair?",
    "3j": "Do you have Blood Pressure problem?",
  },
};

export const DISABLED_QUESTION = ["phone_number", "first_name", "email", "gender", "C1d"];

export const RETAKE_FORM_ACCESS = [ROLES_NAME.LEAD_AGENT, ROLES_NAME.LEAD_AGENT, ROLES_NAME.IVR, ROLES_NAME.CHAT, ROLES_NAME.SUPER_ADMIN, ROLES_NAME.CHAT_CALL_AGENT];
